import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CheckInWidgetFormType } from '@com-delta-idp/mnx-capability-check-in-ui';
import { REG_EXP } from '@com-delta-idp/mnx-sitewide-shared-utils';

@Injectable({
  providedIn: 'root'
})
export class CheckInFormService {
  createCheckInForm(): FormGroup<CheckInWidgetFormType> {
    return new FormGroup({
      findTripBy: new FormControl(''),
      findTripByValue: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(6),
        Validators.pattern(REG_EXP.NEW_CONFIRMATION_NUMBER)
      ]),
      lastName: new FormControl('', [
        Validators.maxLength(50),
        Validators.pattern(REG_EXP.LAST_NAME)
      ]),
      originAirportCode: new FormControl('', [Validators.required])
    });
  }
}
